export default {
  setSummary: (state, payload) => {
    state.summary = payload
  },
  setPageRegister: (state, payload) => {
    state.pageRegister = payload
  },
  setCustomers: (state, payload) => {
    state.customers = payload
  },
  setSalesManagers: (state, payload) => {
    state.salesManagers = payload
  },
  setBidNumber: (state, payload) => {
    state.bidNumber = payload
  },
  setCustomer: (state, payload) => {
    state.customer = payload
  },
  // Specification
  setSpecifications: (state, payload) => {
    state.specifications = payload
  },
  /**
   * @deprecated bid/site/mutations
   */
  addSite: (state, payload) => {
    if (state.specifications.site !== null) {
      state.specifications.site.push(payload)
    }
  },
  /**
   * @deprecated bid/site/mutations
   */
  updateSite: (state, payload) => {
    if (state.specifications.site !== null) {
      const index = state.specifications.site.findIndex(item => {
        return parseInt(item.id) === parseInt(payload.id)
      })
      state.specifications.site.splice(index, 1, payload)
    }
  },
  setSiteForUpdate: (state, payload) => {
    state.siteItem = payload ?? {}
  },
  setComments: (state, payload) => {
    if (state.specifications.comments !== null) {
      state.specifications.comments = payload
    }
  },
  // Decision
  setBidDecisionCriteriaSets: (state, payload) => {
    state.bidDecisionCriteriaSets = payload
  },
  setBidDecisionSettings: (state, payload) => {
    state.bidDecisionSettings = payload
  },
  setBidDecision: (state, payload) => {
    state.bidDecision = payload
    if (state?.bidNumber !== null) {
      state.bidDecision.bidNumber = state.bidNumber
    }
  },
  setDecisionSet: (state, payload) => {
    state.decisionSet = payload
    state.customer = payload.customer
    state.bidDecisionSettings = payload.decision.settings
    state.bidDecisionCriteriaSets = payload.decision.calculation
  },
  // Selected PinPoint
  setCoordinates: (state, payload) => {
    state.coordinates = payload
  },
  // Selected PinPoint
  setCenterCoord: (state, payload) => {
    state.centerCoordinates = payload
  },
  // GoogleGeoCode
  setGeoCode: (state, payload) => {
    state.geocode = payload
  },
  setAuthority: (state, payload) => {
    state.authority = payload
  },
  setRoadSpeed: (state, payload) => {
    state.roadspeed = payload
  },
  // Set Arms of Site
  setArms: (state, payload) => {
    state.arms = payload
  },
  resetArms: state => {
    state.arms = []
  },
  addArm: (state, payload) => {
    state.arms.push(payload)
  },
  updateSiteArms: (state, payload) => {
    const index = state.specifications.site.findIndex(item => {
      return parseInt(item.id) === parseInt(payload.id)
    })
    state.specifications.site[index].arms = payload.arms
  },
  updateArm: (state, payload) => {
    if (state.arms !== null) {
      state.arms = state.arms.map(item => (item.arm.toString() === payload.arm.toString() ? payload : item))
    }
  },
  removeArm: (state, payload) => {
    const index = state.arms.indexOf(payload)
    state.arms.splice(index, 1)
  },
  setCpTypeArmCount: (state, payload) => {
    state.cpTypeArmCount = payload
  },
  setKitType: (state, payload) => {
    state.kitType = payload
  },
  // Project Overview Invoice
  setDetails: (state, payload) => {
    state.specifications.overview.details = payload
  },
  setInvoice: (state, payload) => {
    const collection = state.specifications?.overview?.invoices?.collection
    const index = collection.findIndex(item => {
      return parseInt(item.id) === parseInt(payload?.id)
    })
    if (index !== -1) {
      collection.splice(index, 1, payload)
    } else {
      collection.push(payload)
    }
  },
  removeInvoice: (state, payload) => {
    const collection = state.specifications?.overview?.invoices?.collection
    const index = collection.findIndex(item => {
      return parseInt(item.id) === parseInt(payload?.id)
    })
    collection.splice(index, 1)

    const accrual = state.specifications?.overview?.invoices?.accrual
    const indexInvoice = accrual.findIndex(item => {
      return parseInt(item.invoiceId) === parseInt(payload?.id)
    })
    accrual.splice(indexInvoice, 1)

    const deferral = state.specifications?.overview?.invoices?.deferral
    const deferralInvoice = deferral.findIndex(item => {
      return parseInt(item.invoiceId) === parseInt(payload?.id)
    })
    deferral.splice(deferralInvoice, 1)
  },
  // Attachment of Bid
  addAttachment: (state, payload) => {
    const collection = state.specifications?.attachments
    payload.forEach(payloadItem => {
      const index = collection?.findIndex(item => {
        return parseInt(item.id) === parseInt(payloadItem?.id)
      })
      if (index !== -1) {
        collection.splice(index, 1, payloadItem)
      } else {
        collection.push(payloadItem)
      }
    })
  },
  removeAttachment: (state, payload) => {
    const collection = state.specifications?.attachments
    const index = collection.findIndex(item => {
      return parseInt(item.id) === parseInt(payload?.id)
    })
    collection.splice(index, 1)
  },
  setAccrual: (state, payload) => {
    const collection = state.specifications?.overview?.invoices?.accrual
    const index = collection.findIndex(item => {
      return parseInt(item.id) === parseInt(payload?.id)
    })
    if (index !== -1) {
      collection.splice(index, 1, payload)
    } else {
      collection.push(payload)
    }
  },
  removeAccrual: (state, payload) => {
    const collection = state.specifications?.overview?.invoices?.accrual
    const index = collection.findIndex(item => {
      return parseInt(item.id) === parseInt(payload?.id)
    })
    collection.splice(index, 1)
  },
  setDeferral: (state, payload) => {
    const collection = state.specifications?.overview?.invoices?.deferral
    const index = collection.findIndex(item => {
      return parseInt(item.id) === parseInt(payload?.id)
    })
    if (index !== -1) {
      collection.splice(index, 1, payload)
    } else {
      collection.push(payload)
    }
  },
  removeDeferral: (state, payload) => {
    const collection = state.specifications?.overview?.invoices?.deferral
    const index = collection.findIndex(item => {
      return parseInt(item.id) === parseInt(payload?.id)
    })
    collection.splice(index, 1)
  },
  setFeeAdjustment: (state, payload) => {
    state.specifications.overview.invoices.adjustment.fee = payload.fee ?? { value: 0, type: 1 }
    state.specifications.overview.details = payload.details
  },
  removeFeeAdjustment: (state, payload) => {
    state.specifications.overview.invoices.adjustment.fee = { value: 0, type: 1 }
    state.specifications.overview.details = payload.details
  },
  setZoom: (state, payload) => {
    state.mapSettings.zoom = payload
  },
  setPurchaseNumber(state, payload) {
    if (state.specifications.overview) {
      state.specifications.overview = {
        ...state.specifications.overview,
        purchaseNumber: payload,
      }
    }
  },
}
